<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">LAN Host</h4>
        <div class="change">
            <label for="">IPv4 Address:</label>
            <i v-text="ip"></i>
        </div>
        <div class="change">
            <label for="">Subnet Mask:</label>
            <i v-text="mask"> </i>
        </div>
        <div class="change">
            <label for="">Default Gataway:</label>
            <i v-text="gateway"></i>
        </div>
        <div class="change">
            <label for="" >IPv6 Address:</label>
            <i v-text="fh_lan_addr6"></i>
        </div>
        <div class="change">
            <label for="">MAC Address:</label>
            <i v-text="hwaddr"></i>
        </div>

    <h4 class="title-topic">LAN Ethernet</h4>
 <el-table :data="lanData" stripe style="width: 100%" border class="fhv-table">
    <el-table-column prop="interface" label="Interface"></el-table-column>
    <el-table-column prop="status" label="Status" ></el-table-column>
    <el-table-column prop="speed" label="Speed"></el-table-column>
    <el-table-column prop="duplex" label="Duplex"></el-table-column>
  </el-table>
    </div>
</template>



<script>
export default {
  data() {
    return {
      loading:false,
      ip:"",
      mask:"",
      gateway:"",
      fh_lan_addr6:"",
      hwaddr:"",
      lanData: []
    };
  },
  methods: {
    getData() {
      this.loading=true;
       axios.post("/boafrm/getLanStatus").then((res) => {
         this.loading=false;
         this.ip= res.data.ip;
         this.mask= res.data.mask;
         this.gateway= res.data.gateway;
         this.fh_lan_addr6= res.data.fh_lan_addr6;
         this.hwaddr= res.data.hwaddr;
       });
        this.loading=true;
      axios.post("/boafrm/getLanInfo").then((res) => {
          this.loading=false;
        if(typeof res.data == "string"){
          var data = res.data.replace(/\s/g, "");
        }else{
          return
        }
        let dataObj = JSON.parse(data);
        const lanNum = this.$G_DEVICE_CFG.lanNum
        if (dataObj.result == 1) {
          for (var i = 0; i < dataObj.data.length - 1; i++) {
            if(lanNum <= 2 && i < 2) continue;
            if (dataObj.data[i].all) {
              var speed = dataObj.data[i].all.split("Speed")[1];
              if (dataObj.data[i].all.indexOf("Enabled") != -1) {
                var duplex = "Full Duplex";
              } else if (dataObj.data[i].all.indexOf("Disable") != -1) {
                var duplex = "Half  Duplex";
              }
            } else {
              var speed = "-";
              var duplex = "-";
            }
            
            let lanName
            if(lanNum <= 2)
                lanName = `LAN${i - 1}`
            else
                lanName = dataObj.data[i].port
            this.lanData.push({
            interface:lanName,
            status:dataObj.data[i].status,
            speed:speed,
            duplex:duplex
            });
          }
         
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>





